import React from 'react';
import { motion } from 'framer-motion';
import { PlusIcon, BuildingIcon, TrashIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface BankAccountsProps {
  navigate: (screen: string) => void;
}
export function BankAccounts({
  navigate
}: BankAccountsProps) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex-1 overflow-y-auto pb-safe bg-slate-50" data-id="element-969">
      <TopBar title="Bank Accounts" showBack onBack={() => navigate('profile')} data-id="element-970" />

      <div className="px-5 pt-6 pb-8" data-id="element-971">
        <div className="space-y-4 mb-8" data-id="element-972">
          {/* Linked Account */}
          <div className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex items-center justify-between" data-id="element-973">
            <div className="flex items-center gap-4" data-id="element-974">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600" data-id="element-975">
                <BuildingIcon className="w-6 h-6" data-id="element-976" />
              </div>
              <div data-id="element-977">
                <h3 className="font-bold text-[#0D3B3B] text-sm" data-id="element-978">
                  Guaranty Trust Bank
                </h3>
                <p className="text-xs text-gray-500 font-medium" data-id="element-979">
                  0123****89 • Adaeze Okonkwo
                </p>
              </div>
            </div>
            <button className="w-8 h-8 rounded-full bg-rose-50 text-rose-500 flex items-center justify-center hover:bg-rose-100 transition-colors" data-id="element-980">
              <TrashIcon className="w-4 h-4" data-id="element-981" />
            </button>
          </div>
        </div>

        <button className="w-full bg-white border border-dashed border-gray-300 hover:border-[#2BA89D] hover:bg-[#2BA89D]/5 text-[#0D3B3B] font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2" data-id="element-982">
          <PlusIcon className="w-5 h-5" data-id="element-983" /> Add New Bank Account
        </button>
      </div>
    </motion.div>;
}